import { render, staticRenderFns } from "./BaseGraphics.vue?vue&type=template&id=272cc154&scoped=true&"
import script from "./BaseGraphics.vue?vue&type=script&lang=js&"
export * from "./BaseGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272cc154",
  null
  
)

export default component.exports